import React, { useRef, useEffect } from "react";
import SsoButtons from "./SsoButtons.js";
import {getSsoStatus} from "../lib/functions";

export default class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ssostatus : props.student.ssostatus
    }
  }

  updateSsoStatus = () => {
      getSsoStatus((data) => {
          this.setState({ssostatus : data[0].ssostatus});
      });
  }

  render() {
  return (


  <div>

    <div className="white-box page-text">

    <div className="page-section-header">SSO Setup 
      <i className="fa fa-info-circle text-ep-primary help-button" data-url="https://stsupport.exampro.co.uk/kb/?lnd=7E6" onClick={this.props.gethelp}></i>
    </div>
    <p>Link your Google or Microsoft account to make logging in much easier.</p>
    <p>Click the provider you would like to link:</p>

        <div className="sso-field">
        <SsoButtons type="link" statuslisten={this.updateSsoStatus} linked={this.state.ssostatus}/>
        </div>

        {this.state.ssostatus == -1 ?
          <div className="sso-status text-dark">...</div>
          : ''
        }
        {this.state.ssostatus == 0 ?
          <div className="sso-status text-dark">Account not linked</div>
          : ''
        }
        {this.state.ssostatus == 1 ?
          <div className="sso-status text-green"><i className="fa fa-check-circle"></i>&nbsp;Successfully linked with Google</div>
          : ''
        }
        {this.state.ssostatus == 2 ?
          <div className="sso-status text-green"><i className="fa fa-check-circle"></i>&nbsp;Successfully linked with Microsoft</div>
          : ''
        }

    </div>

</div>
  )}
}
